import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';

import { ApiProvider } from 'api';
import { PublicApiProvider } from 'public-api';
import ToastStore, { ToastStoreContext } from 'ui/toast/ToastStore';

type Props = {
  children?: React.ReactNode;
};

function AuthContextProviders({ children }: Props) {
  const [toastStore] = useState(() => new ToastStore());

  useEffect(() => {
    window.appState.toastStore = toastStore;
  }, [toastStore]);

  return (
    <ApiProvider>
      <PublicApiProvider>
        <ToastStoreContext.Provider value={toastStore}>{children}</ToastStoreContext.Provider>
      </PublicApiProvider>
    </ApiProvider>
  );
}

export default observer(AuthContextProviders);
